var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPageBackIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 21,
  fill: "none",
  viewBox: "0 0 20 21"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#75899D",
  strokeWidth: 2,
  d: "M11.667 6.333 7.5 10.281l4.167 3.947"
})));
export { SvgPageBackIcon as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMCAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTExLjY2NjcgNi4zMzMyNUw3LjUwMDAyIDEwLjI4MDZMMTEuNjY2NyAxNC4yMjgiIHN0cm9rZT0iIzc1ODk5RCIgc3Ryb2tlLXdpZHRoPSIyIi8+Cjwvc3ZnPgo=";